'use client';

import { useMemo } from 'react';
import { useStore } from 'zustand';

import { authStore } from '@/infrastructure/store/authStore';

import { contaAtiva, IContaAtiva } from '../helpers/contaAtiva';

/**
 * The account picked in the unified login: its name and logo, as registered in the uMode
 * dashboard. It is session data already in hand, so it costs no request.
 */
export function useContaAtiva(): IContaAtiva {
  const partnersList = useStore(authStore, (s) => s.partnersList);
  const partnerId = useStore(authStore, (s) => s.user?.partnerId ?? '');

  return useMemo(() => contaAtiva(partnersList, partnerId), [partnersList, partnerId]);
}
